import AuthorTable from "../admin/AuthorTable";
import React, { useState } from "react";
import AdminLayout from "./component/AdminLayout";

const AuthorEnrollList = () => {
    const [status, setStatus] = useState<string>('PENDING');

    const handleTabClick = (status: string) => {
        setStatus(status);
    };

    const tabs = [
        { id: 'PENDING', label: '승인 대기', color: 'primary' },
        { id: 'SUSPENDED', label: '반려', color: 'danger' },
        { id: 'HOLD', label: '비활성화', color: 'warning' },
    ];

    return (
        <AdminLayout
            pageTitle="작가 심사"
            breadcrumbs={[
                { label: 'Home', link: '/admin' },
                { label: 'Author Proposals', active: true }
            ]}
        >

            {/* [ Main Content ] */}
            <div className="main-content">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card border-0 shadow-sm mb-4">
                            <div className="card-header p-0 bg-white border-bottom">
                                <ul className="nav nav-tabs nav-tabs-custom-style border-bottom-0 flex-nowrap w-full overflow-y-hidden"

                                    role="tablist">
                                    {tabs.map((tab) => (
                                        <li className="nav-item" key={tab.id} style={{ flex: 1 }}>
                                            <a
                                                className={`nav-link py-3 text-center fw-bold fs-13 position-relative ${status === tab.id ? 'active text-primary' : 'text-muted'}`}
                                                onClick={() => handleTabClick(tab.id)}
                                                style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                                            >
                                                {tab.label}
                                                {/* 활성화 시 하단 바 애니메이션 효과 */}
                                                {status === tab.id && (
                                                    <span className="position-absolute bottom-0 start-0 w-100 bg-primary" style={{ height: '3px' }}></span>
                                                )}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* 테이블 영역 */}
                            <div className="card-body p-0">
                                <div className="p-4 bg-light-subtle border-bottom">
                                    <h6 className="mb-0 fw-bold">
                                        <i className="feather-list me-2"></i>
                                        {tabs.find(t => t.id === status)?.label} 리스트
                                    </h6>
                                </div>
                                <AuthorTable status={status} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
                .nav-tabs-custom-style .nav-link {
                    border: none;
                    background: none;
                }
                .nav-tabs-custom-style .nav-link:hover {
                    background-color: #f8f9fa;
                    color: #6366f1 !important;
                }
                .nav-tabs-custom-style .nav-link.active {
                    background-color: #fff;
                }
            `}</style>
        </AdminLayout>
    );
};

export default AuthorEnrollList;